// extracted by mini-css-extract-plugin
module.exports = {"swiper":"SignGiftList_swiper_7VfZw","swiper-item":"SignGiftList_swiper-item_YrLIz"};